import * as PIXI from "pixi.js";

export class ColorOverlayFilter extends PIXI.Filter {

    private static readonly FRAG: string = `
        varying vec2 vTextureCoord;
        uniform sampler2D uSampler;
        uniform vec3 color;
        uniform float alpha;
        void main(void) {
            vec4 currentColor = texture2D(uSampler, vTextureCoord);
            vec3 colorOverlay = color * currentColor.a;
            gl_FragColor = vec4(
                currentColor.r * (1.0 - alpha) + colorOverlay.r * alpha,
                currentColor.g * (1.0 - alpha) + colorOverlay.g * alpha,
                currentColor.b * (1.0 - alpha) + colorOverlay.b * alpha,
                currentColor.a);
        }
    `;

    private _color!: number;
    private _alpha!: number;

    constructor(color: number | [number, number, number] = 0x000000, alpha = 1) {
        super(undefined, ColorOverlayFilter.FRAG);
        this.uniforms.color = new Float32Array(3);
        this.uniforms.alpha = alpha;
        this.color = color;
        this.padding = 0;
        this._alpha = alpha;
    }

    /**
     * The resulting color, as a 3 component RGB e.g. [1.0, 0.5, 1.0]
     * @member {number|Array<number>}
     * @default 0x000000
     */
    set color(value: number | [number, number, number]) {
        const arr = this.uniforms.color;
        if (typeof value === "number") {
            PIXI.utils.hex2rgb(value, arr);
            this._color = value;
        } else {
            arr[0] = value[0];
            arr[1] = value[1];
            arr[2] = value[2];
            this._color = PIXI.utils.rgb2hex(arr);
        }
    }

    get color(): number | [number, number, number] {
        return this._color;
    }

    get alpha(): number {
        return this._alpha;
    }

    set alpha(value: number) {
        this._alpha = value;
    }
}
